import React from "react"
import { Box, Link, Heading } from "theme-ui"
import { format } from "date-fns"

const Published = ({ date }) => {
  try {
    const formatted = format(new Date(date), "MMMM do, yyyy")
    return (
      <>
        <br />
        <small>
          <em>{formatted}</em>
        </small>
      </>
    )
  } catch (e) {
    return null
  }
}

const ArticleListing = ({
  fields: { slug },
  frontmatter: { title, description, published },
}) => {
  if (!title && !description && !published) {
    return null
  }

  let href = slug.startsWith("/") ? slug : `/${slug}`
  if (!href.endsWith("/")) {
    href += "/"
  }

  return (
    <Box sx={{ mb: 4 }}>
      <Link href={href}>
        <Heading>{title}</Heading>
      </Link>

      <p>
        {description}
        {published ? <Published date={published} /> : null}
      </p>
    </Box>
  )
}

export default ArticleListing
